(function (Drupal, debounce) {
  Drupal.behaviors.filterWorks = {
    /**
     *
     * @param {HTMLElement} form
     * @param {object} queryParams
     */
    fetch(form, queryParams) {
      return new Promise((resolve, reject) => {
        let path = form.getAttribute('action');
        queryParams['theme_id'] = form.getAttribute('data-theme');
        queryParams = new URLSearchParams(queryParams);
        path += '?' + queryParams.toString();
        fetch(path, {
          method: form.getAttribute('method')
        }).then(response => {
            resolve(response.json());
          })
          .catch(response => reject(response))
      })
    },
    updateContent(items) {
      document
        .querySelectorAll('.view-photo-contest-works')
        .forEach(el => {
          el.innerHTML = '';

          items.forEach(item => {
            let itemHtml = '<div class="col">' + item + '</div>';
            el.innerHTML += itemHtml;
          })
        })
    },
    /**
     *
     * @param {Event} e
     */
    submitHandler(e) {
      e.preventDefault();
      document
        .querySelectorAll('#query_text')
        .forEach(el => {

          if (el.value.length < 2) {
            return;
          }

          Drupal.behaviors.filterWorks.fetch(e.target, {'keys': el.value})
            .then(result => {
              Drupal.behaviors.filterWorks.updateContent(result);
            })
        })
    },
    attach(context) {
      context = context || document;
      // Submit form.
      context
        .querySelectorAll('.contest-list__search')
        .forEach(el => {
          el.addEventListener('submit', this.submitHandler);
        })
      // Input search test.
      context
        .querySelectorAll('#query_text')
        .forEach(el => {
          el.addEventListener('input', debounce(e => {
            if (e.target.value.length < 2) {
              return;
            }

            Drupal.behaviors.filterWorks.fetch(e.target.closest('form'), {'keys': e.target.value})
              .then(result => {
                Drupal.behaviors.filterWorks.updateContent(result);
              })
          }, 200));
        })
      // Click sort elements.
      let sortElems = context
        .querySelectorAll('.contest-list__sort [data-sort]');
      sortElems
        .forEach(el => {
          el.addEventListener('click', e => {
            e.preventDefault();
            let form = e
              .target
              .closest('.contest-list__filters')
              .querySelector('form');

            Drupal.behaviors.filterWorks.fetch(form, {'sort': e.target.getAttribute('data-sort')})
              .then(result => {
                Drupal.behaviors.filterWorks.updateContent(result);
              })

            sortElems.forEach(el => {
              el.classList.remove('active');
            })
            e.target.classList.add('active');
          })
        })
    }
  }
}(Drupal, Drupal.debounce))
